import React from 'react';

import { Link } from 'react-router-dom';

import ModeEditTwoToneIcon from '@mui/icons-material/ModeEditTwoTone';
import IconButton from '@mui/material/IconButton';

import Image from '../../Common/Image';

type Props = {
  offer: App.Offer & {
    badges?: Array<{
      name: string;
      image: string;
    }>;
  };
};

export default function BadgesPane({ offer }: Props) {
  return (
    <span>
      <h1>
        <Link to={'/edit-offers/' + offer.id_salesforce_external + '/badges'}>
          <IconButton aria-label="Edit">
            <ModeEditTwoToneIcon fontSize="large" />
          </IconButton>
        </Link>
      </h1>
      <div className="badges-list">
        {offer?.badges?.map((badge, index) => (
          <div className="badge-tile" key={`${badge.name}-${index}`}>
            <div className="cover">
              <Image className="img-responsive img-thumbnail" publicId={badge.image} options={{ width: 130 }} />
            </div>
            <div>{badge.name}</div>
          </div>
        ))}
      </div>
    </span>
  );
}
